var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareLinkedin = function SvgShareLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0678B5",
    fillRule: "nonzero",
    d: "M5.255 19.604H.463V7.146h4.792zM2.851 5.23h-.03C1.375 5.23.438 4.096.438 2.852.437 1.578 1.403.54 2.878.54c1.477 0 2.385 1.071 2.414 2.345 0 1.245-.937 2.344-2.441 2.344m11.029 5.75a1.917 1.917 0 0 0-1.917 1.917v6.708H7.172s.056-11.5 0-12.458h4.791v1.423s1.484-1.383 3.774-1.383c2.839 0 4.851 2.055 4.851 6.041v6.377h-4.791v-6.708a1.917 1.917 0 0 0-1.917-1.917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h23v23H-1z"
  }))));
};
export default SvgShareLinkedin;